export const SUPPORTED_DOC_LIST_URLS = {
  au: "https://assets.latitudefinancial.com/proof-of-income/POI-Verification-Table.pdf",
  nz: "https://www.gemfinance.co.nz/supporting-documents/?tlga=545625902.1710975403&adobe_mc=MCMID%3D25144401797892332934878655815595202882%7CMCORGID%3DB6D9B74F57B2FBE97F000101%2540AdobeOrg%7CTS%3D1731911903"
}

export const BANK_CONNECT_URLS_AU = {
  TERMS_AND_CONDITIONS: "https://www.bankstatements.com.au/about/terms",
  PRIVACY_POLICY: "https://www.illion.com.au/privacy-policy-risk-marketing-solutions/"
}

export const BANK_CONNECT_URLS_NZ = {
  TERMS_AND_CONDITIONS: "https://www.bankstatements.co.nz/about/terms",
  PRIVACY_POLICY: "https://illion.co.nz/privacy-policy-risk-marketing-solutions/"
}
